<template>
  <v-app class="login-img">
    <v-snackbar v-model="snackbar" timeout="3000" color="success">
      {{ snackbarMessage }}
      <v-btn color="white" text @click="snackbar = false"> Close </v-btn>
    </v-snackbar>
    <v-navigation-drawer color="sidebar" :class="['login-sidebar pa-7', { 'white-menu-sidebar': useWhiteMenu }]" permanent floating>
      <router-link to="/">
        <v-img
          :src="require('@/assets/vernier.png')"
          max-width="200"
          class="mx-auto"
        ></v-img>
      </router-link>
      <v-alert type="error" class="mt-5" v-if="error === true">
        {{ errorMessage }}
      </v-alert>
      
      <!-- Password Requirements -->
      <v-card outlined class="mt-5 mb-3" color="info" dark>
        <v-card-title class="subtitle-2 pa-3 pb-2">
          <v-icon small left>mdi-information</v-icon>
          Password Requirements:
        </v-card-title>
        <v-card-text class="pa-3 pt-2">
          <ul class="ma-0 pl-4" style="font-size: 0.875rem; line-height: 1.6;">
            <li>At least 5 characters long</li>
            <li>At least one uppercase letter (A-Z)</li>
            <li>At least one number (0-9)</li>
            <li>Both password fields must match</li>
          </ul>
        </v-card-text>
      </v-card>
      
      <v-form ref="form" class="mt-5">
        <v-text-field
          v-model="password"
          label="New Password"
          required
          outlined
          dark
          prepend-inner-icon="mdi-lock"
          color="white"
          :rules="passwordRules"
          type="password"
          hint="Must have 5+ characters, one uppercase letter, and one number"
          persistent-hint
          @keydown.enter="validate"
        ></v-text-field>
        <v-text-field
          v-model="confirmPassword"
          label="Confirm New Password"
          required
          outlined
          dark
          color="white"
          prepend-inner-icon="mdi-lock-check"
          :rules="passwordConfirm"
          type="password"
          hint="Must match the new password"
          persistent-hint
          @keydown.enter="validate"
        ></v-text-field>
      </v-form>
      <div class="d-flex flex-wrap ga-2 mt-2">
        <v-btn
          :disabled="!valid || !password || !confirmPassword || password !== confirmPassword"
          depressed
          color="secondary"
          class="px-5"
          @click="validate"
        >
          Change Password
        </v-btn>
        <v-btn
          outlined
          color="grey"
          class="px-5"
          @click="cancelPasswordChange"
        >
          Cancel
        </v-btn>
      </div>

      <v-list>
        <v-list-item class="sidebar-bottom-text">
          <v-btn
            text
            class="mx-auto"
            color="secondary"
            href="https://vernier.health"
            target="_blank"
          >
            Powered by Vernier Health
          </v-btn>
        </v-list-item>
      </v-list>
      <v-spacer></v-spacer>
    </v-navigation-drawer>
    <div class="welcome-text d-none d-lg-block">
      <div class="display-3">Change Password.</div>
      <div class="overline">Please fill the form to change your password.</div>
    </div>
  </v-app>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      valid: true,
      password: '',
      user: '',
      confirmPassword: '',
      error: false,
      errorMessage: '',
      snackbar: false,
      snackbarMessage: '',
      token: '',
      expiryCheckInterval: null,
      passwordRules: [
        v => !!v || 'Password required',
        v => (v && v.length >= 5) || 'Password must have 5+ characters',
        v => /(?=.*[A-Z])/.test(v) || 'Must have one uppercase character',
        v => /(?=.*\d)/.test(v) || 'Must have one number',
      ],
      passwordConfirm: [
        v => !!v || 'Confirm password',
        v => v === this.password || 'Passwords do not match',
      ],
    };
  },
  mounted() {
    this.token = this.$route.params.token;

    // Se chegou via link direto (email), salvar token e expiry no localStorage (2h)
    if (this.token && !localStorage.getItem('resetPasswordToken')) {
      localStorage.setItem('resetPasswordToken', this.token);
      const expiry = Date.now() + 2 * 60 * 60 * 1000;
      localStorage.setItem('resetPasswordTokenExpiry', String(expiry));
    }

    this.checkTokenExpiry();
    this.expiryCheckInterval = setInterval(this.checkTokenExpiry, 5 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.expiryCheckInterval) clearInterval(this.expiryCheckInterval);
  },
  computed: {
    useWhiteMenu() {
      return process.env.VUE_APP_WHITE_MENU === 'true';
    },
  },
  methods: {
    checkTokenExpiry() {
      const expiry = localStorage.getItem('resetPasswordTokenExpiry');
      if (expiry && Date.now() > parseInt(expiry, 10)) {
        if (this.expiryCheckInterval) clearInterval(this.expiryCheckInterval);
        localStorage.removeItem('resetPasswordToken');
        localStorage.removeItem('resetPasswordTokenExpiry');
        this.error = true;
        this.errorMessage = 'This password change link has expired. Please request a new one.';
        setTimeout(() => this.$router.push('/login'), 3000);
      }
    },
    cancelPasswordChange() {
      localStorage.removeItem('resetPasswordToken');
      localStorage.removeItem('resetPasswordTokenExpiry');
      this.$router.push('/login');
    },
    // async getUser() {
    //   await axios
    //     .get('/api/user')
    //     .then((response) => {
    //       this.user = response.data[0];
    //     })
    //     .catch((err) => this.$router.push('/login'));
    // },
    validate(e) {
      if (e) {
        e.preventDefault();
      }
      
      console.log('🔐 Pwchange: validate() called');
      console.log('🔐 Token:', this.token);
      console.log('🔐 Password length:', this.password ? this.password.length : 0);
      console.log('🔐 Confirm password length:', this.confirmPassword ? this.confirmPassword.length : 0);
      
      if (this.$refs.form && this.$refs.form.validate()) {
        console.log('✅ Form validation passed');
        this.updateUser(e);
      } else {
        console.log('❌ Form validation failed');
        this.error = true;
        this.errorMessage = 'Please fill all fields correctly';
      }
    },
    updateUser(e) {
      if (e) {
        e.preventDefault();
      }

      if (!this.token) {
        console.error('❌ No token found');
        this.error = true;
        this.errorMessage = 'Invalid token. Please request a new password reset.';
        return;
      }

      if (!this.password || this.password.length < 5) {
        console.error('❌ Invalid password');
        this.error = true;
        this.errorMessage = 'Password must be at least 5 characters long';
        return;
      }

      if (this.password !== this.confirmPassword) {
        console.error('❌ Passwords do not match');
        this.error = true;
        this.errorMessage = 'Passwords do not match';
        return;
      }

      const { password } = this;
      const data = {
        password,
      };
      
      console.log('🔐 Sending password reset request to:', `/api/reset-password/${this.token}`);
      
      axios
        .post(`/api/reset-password/${this.token}`, data)
        .then((response) => {
          console.log('✅ Password reset successful:', response.data);
          this.snackbarMessage = 'Your password has been changed';
          this.snackbar = true;
          this.error = false;
          this.errorMessage = '';
          
          localStorage.removeItem('resetPasswordToken');
          localStorage.removeItem('resetPasswordTokenExpiry');
          
          // Atualizar firstLogin no localStorage se o usuário estiver salvo
          const userData = localStorage.getItem('user');
          if (userData) {
            try {
              const user = JSON.parse(userData);
              user.firstLogin = false;
              localStorage.setItem('user', JSON.stringify(user));
            } catch (e) {
              console.error('Error updating user data:', e);
            }
          }
          
          // Verificar se é FamilyHealthChoice para redirecionar corretamente
          let isFamilyHealthChoice = false;
          
          if (userData) {
            try {
              const user = JSON.parse(userData);
              isFamilyHealthChoice = user && user.insurance && 
                Array.isArray(user.insurance) &&
                user.insurance.some(ins => 
                  ins === 'FamilyHealthChoice' || ins === 'FloridaHealthChoice'
                );
            } catch (e) {
              console.error('Error parsing user data:', e);
            }
          }
          
          console.log('🔐 Is FamilyHealthChoice:', isFamilyHealthChoice);
          
          // Add a delay of 2 seconds (2000 milliseconds) before redirecting
          setTimeout(() => {
            if (isFamilyHealthChoice) {
              // Para FamilyHealthChoice, redirecionar para /member-enrollment
              console.log('🔐 Redirecting to /member-enrollment');
              this.$router.push('/member-enrollment');
            } else {
              // Para outros clientes, redirecionar para login
              console.log('🔐 Redirecting to /login');
              this.$router.push('/login');
            }
          }, 2000);
        })
        .catch((errors) => {
          console.error('❌ Password reset error:', errors);
          this.error = true;
          
          if (errors.response && errors.response.data && errors.response.data.message) {
            this.errorMessage = errors.response.data.message;
          } else if (errors.response && errors.response.status === 400) {
            this.errorMessage = 'Password reset token is invalid or has expired.';
          } else if (errors.response && errors.response.status === 500) {
            this.errorMessage = 'Server error. Please try again later.';
          } else {
            this.errorMessage = errors.message || 'An error occurred while resetting your password.';
          }
          
          console.error('Error message:', this.errorMessage);
        });
    },
  },
};
</script>
<style scoped>
.sidebar-bottom-text {
  position: fixed !important;
  bottom: 10px;
  left: 0;
  width: 100%;
}

.login-img {
  background-image: url(../assets/login.jpg);
  background-size: cover;
}

.welcome-text {
  position: absolute;
  top: 45%;
  left: 450px;
}

/* White menu styling for password change - Only applies when VUE_APP_WHITE_MENU=true */
.v-navigation-drawer.white-menu-sidebar {
  background-color: white !important;
  
  /* Global text color override */
  * {
    color: #333333 !important;
  }

  /* Form field labels and text - force override */
  .v-text-field .v-label,
  .v-text-field label,
  .v-text-field .v-input__slot,
  .v-select .v-label,
  .v-select label {
    color: #333333 !important;
  }

  /* Input text color - force override */
  .v-text-field input,
  .v-text-field .v-text-field__slot input,
  .v-select .v-select__selection {
    color: #333333 !important;
  }

  /* Button styling - preserve button colors */
  .v-btn:not(.v-btn--text):not(.v-btn--outlined) {
    color: white !important;
  }
  
  .v-btn.v-btn--text {
    color: #333333 !important;
  }

  /* Keep alert colors intact */
  .v-alert,
  .v-alert * {
    color: inherit !important;
  }

  /* Icons in form fields */
  .v-input__icon .v-icon,
  .v-text-field .v-input__prepend-inner .v-icon,
  .v-input__prepend-outer .v-icon,
  .v-input__append-outer .v-icon {
    color: #666666 !important;
  }

  /* Card text */
  .v-card-text,
  .v-card-text *,
  .v-card-actions,
  .v-card-actions * {
    color: #333333 !important;
  }
  
  /* But preserve button text colors in cards */
  .v-card-actions .v-btn:not(.v-btn--text) {
    color: white !important;
  }
}
</style>
